import { useCallback } from 'react';
import { SYSTEM_DATE_FORMAT } from '../../constants';
import { dateFormat } from '../../utils';
import DateInput from '../DateInput';

/** @param {{ selectedDate: string, onChange: function(string): void }} props */
export const PortfolioDatePicker = function PortfolioDatePicker({ selectedDate, onChange }) {
    const handleDateChange = useCallback((event) => {
        onChange(moment(event.date).format(SYSTEM_DATE_FORMAT));
    }, [onChange]);

    return (
        <div className="box box-solid">
            <div className="box-body">
                <div className="hstack form-group mb-0">
                    <DateInput
                        className="form-control"
                        value={dateFormat(selectedDate)}
                        showTodayButton={true}
                        onChange={handleDateChange}
                    />
                </div>
            </div>
        </div>
    );
};
